<template>
  <div class="success-content fill-height">
    <div class="success-title">Thank you for your purchase!</div>
    <div class="success-body">
      <div v-if="userAuth" class="cursor-pointer" @click="goToOrder(orderNo)">
        Your order number is:
        <span class="font-weight-bold">{{ orderProduct.incrementId }}</span>
      </div>
      <div v-if="!userAuth">
        Your order number is:
        <span class="font-weight-bold">{{ orderProduct.incrementId }}</span>
      </div>
      <div>
        We’ll email you an order confirmation with details and tracking info
      </div>
    </div>
    <div class="success-action">
      <v-btn
        class="text-none"
        variant="flat"
        color="primary"
        tile
        height="44"
        @click="goToHomePage()"
      >
        Continue Shopping
      </v-btn>
      <div
        class="d-flex align-center justify-center ga-2 px-2 py-2"
        style="gap: 10px"
        v-if="userAuth"
      >
        <div
          class="d-flex align-center justify-center cursor-pointer"
          @click="goToOrder(orderNo)"
        >
          <img
            src="@/assets/file.svg"
            alt="File icon"
            class="mr-2 w-4 h-4 text-primary"
            width="20"
            height="20"
          />
          <div class="text-primary">View Order</div>
        </div>
        <v-divider
          class="d-inline d-sm-none border-opacity-25"
          vertical
        ></v-divider>
        <div
          class="d-flex align-center justify-center cursor-pointer"
          @click="printOrder('showInPrint')"
        >
          <img
            src="@/assets/printer.svg"
            alt="File icon"
            class="mr-2 w-4 h-4 text-primary"
            width="20"
            height="20"
          />
          <div class="text-primary">Print Receipt</div>
        </div>
      </div>
    </div>

    <div v-if="!userAuth" class="success-body">
      <v-divider class="custom-divider mb-3" thickness="2"></v-divider>
      <p>You can track your order status by creating an account.</p>
      <p>
        Email Address:
        <span class="font-weight-bold">{{ orderProduct.customerEmail }}</span>
      </p>
    </div>
    <div v-if="!userAuth" class="success-action">
      <v-btn
        class="text-none text-primary"
        color="primary"
        variant="outlined"
        tile
        height="44"
        @click="goToSignUp()"
      >
        Create Account
      </v-btn>
    </div>

    <v-row no-gutters id="showInPrint" class="d-none">
      <v-col cols="12">
        <v-row
          align="center"
          id="showInPrintOnly"
          class="order-products-heading"
        >
          <v-col cols="auto">
            <h1 class="order-product-id">
              Order #{{ orderProduct.incrementId }}
            </h1>
          </v-col>
          <v-col cols="auto">
            <v-btn class="order-product-status" tile variant="outlined" text>
              <span
                class="text-uppercase text-black"
                v-if="
                  orderProduct.status == 'failed_to_ship' ||
                  orderProduct.status == 'waiting_to_ship'
                "
                >Processing Order</span
              >
              <span class="text-uppercase text-black" v-else>{{
                orderProduct.status
              }}</span>
            </v-btn>
          </v-col>
        </v-row>
        <p class="pt-4 mb-3">{{ dateString(orderProduct.createdAt) }}</p>
        <ViewOrderTabs
          :viewOrderItem="orderProduct"
          :productInvoice="productInvoice"
        ></ViewOrderTabs>
      </v-col>
    </v-row>
  </div>
</template>
<script>
const baseUrl = import.meta.env.VITE_BASE_URL;
import FooterComponent from "@/components/layout/footer/FooterComponent.vue";
import ViewOrderTabs from "@/components/me/my-orders/ViewOrderTabs.vue";
import { getCookieByName } from "@/services/auth";
import { mdiFile, mdiPrinter } from "@mdi/js";
const crGuestQuoteId = import.meta.env.VITE_GUEST_QUOTE_ID;

export default {
  name: "OrderSuccess",
  data() {
    return {
      mdiFile,
      mdiPrinter,
    };
  },
  components: {
    FooterComponent,
    ViewOrderTabs,
  },
  watch: {},
  computed: {
    canonical: function () {
      return this.$route.meta.canonical;
    },
    userAuth: function () {
      return this.$store.state.auth.userAuth;
    },
    guestQuoteId: function () {
      return getCookieByName(crGuestQuoteId);
    },
    orderNo: function () {
      return this.$route.params.orderNumber;
    },
    userEmailAddress: function () {
      return JSON.parse(localStorage.getItem("cr_guestShippingAddress"));
    },
    orderProduct() {
      return this.$store.state.meProductOne.orderProduct;
    },
    productInvoice() {
      return this.$store.state.meProductOne.productInvoice;
    },
  },
  metaInfo() {
    return {
      link: [
        {
          rel: "canonical",
          href: `${
            this.canonical ? window.location.href.split("?")[0] : baseUrl
          }`,
        },
      ],
    };
  },
  methods: {
    goToOrder(orderNo) {
      window.open("/me/my-orders/" + orderNo, "_self");
    },
    goToHomePage() {
      this.$router.push({
        name: "HomePage",
      });
    },
    goToSignUp() {
      window.open("/gate/sign-up", "_self");
    },
    printOrder(divName) {
      const prtHtml = document.getElementById(divName).innerHTML;
      let stylesHtml = "";
      for (const node of [
        ...document.querySelectorAll('link[rel="stylesheet"], style'),
      ]) {
        stylesHtml += node.outerHTML;
      }
      const WinPrint = window.open(
        "",
        "",
        "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0"
      );
      WinPrint.document.write(`<!DOCTYPE html>
      <html>
      <head>
      ${stylesHtml}
      </head>
      <body>
      ${prtHtml}
      </body>
      </html>`);
      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },
    isoStringToNormalDate(date) {
      let newDateTime = Date.parse(date);
      let tmp = new Date(newDateTime).toLocaleDateString().split("/");
      return (date = tmp[1] + "/" + tmp[0] + "/" + tmp[2]);
    },
    dateString(date) {
      let newDateTime = Date.parse(date);
      return new Date(newDateTime).toDateString();
    },
  },
  mounted() {},

  created() {
    if (this.userAuth) {
      this.$store.dispatch("userCartProduct/cartProductList");
      this.$store.dispatch("meProductOne/fetchOrderProduct", this.orderNo);
    } else {
      if (this.guestQuoteId) {
        this.$store.dispatch("cartProduct/cartProductList", this.guestQuoteId);
        this.$store.dispatch("cartProduct/productTotalAmt", this.guestQuoteId);
      }
      this.$store.dispatch("meProductOne/fetchOrderProduct", this.orderNo);
    }
  },
};
</script>
<style scoped lang="scss">
.success-content {
  display: flex;
  padding: 10px 100px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 30px;
  flex: 1 0 0;
  align-self: stretch;
  background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #fff 72.15%),
    url("@/assets/order_success.jpg") lightgray -162.588px -225.879px / 155.388%
      126.763% no-repeat;
  background-size: cover;
  background-position: center;

  .custom-divider {
    width: 540px;
    background-color: #cdcdcd;
  }

  @media (max-width: 768px) {
    // mobile
    padding: 10px 40px;
    align-items: center;
    background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, #fff 72.15%),
      url("@/assets/order_success.jpg") lightgray 50% / cover no-repeat;

    .custom-divider {
      width: 100%;
    }
  }

  .success-title {
    color: #000;
    font-family: "Playfair Display", sans-serif;
    font-size: 40px;
    font-style: italic;
    font-weight: 600;
    line-height: 150%; /* 60px */
    @media (max-width: 768px) {
      text-align: center;
    }
  }
  .success-body {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-family: "Montserrat", sans-serif;
    gap: 10px;

    @media (max-width: 768px) {
      align-items: center;
    }
    * {
      color: #0f172b;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 150%; /* 21px */
      @media (max-width: 768px) {
        text-align: center;
      }
    }
  }
  .success-action {
    //padding: 10px 0px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: "Montserrat", sans-serif;
    gap: 10px;
    @media (max-width: 768px) {
      flex-direction: column;
      align-items: center;
    }
  }
}
</style>